import './index.scss'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'
import Swiper from 'swiper/swiper-bundle.min.js'


document.addEventListener('DOMContentLoaded', function() {
    // 初始化Swiper
    var swiper2 = new Swiper(".mySwiper", {
      direction: "vertical",
      spaceBetween: 100,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });
     var swiper = new Swiper(".mySwiper2", {
      direction: "vertical",
      slidesPerView: 1,
      mousewheel: {
        invert: false,
        releaseOnEdges: true,
        sensitivity: 0
    },
    thumbs: {
        swiper: swiper2,
      },
  });

    
    // 监听鼠标滚轮事件，在最后一张幻灯片时允许页面滚动
    swiper.wrapperEl.addEventListener('wheel', function(e) {
        if (swiper.isEnd && e.deltaY > 0) {
            // 在最后一张且向下滚动时，允许页面滚动
            console.log(1);
            
            return;
        }
        
        if (swiper.isBeginning && e.deltaY < 0) {
            // 在第一张且向上滚动时，允许页面滚动
            console.log(2);
            
            return;
        }
        
        // 阻止默认行为，让Swiper处理滚动
        e.preventDefault();
    }, { passive: false });
});